<template>
  <div v-if="renderDescription">
    <template v-if="item.attributes.description || editing">
      <div>
        <h5>Description</h5>
        <b-form-textarea
          v-if="$root.isOwner && editing"
          ref="description"
          id="description"
          @keydown.ctrl.enter.exact.prevent="update"
          @keydown.esc="editing = false"
          @keydown="(e) => e.stopPropagation()"
          @blur="update"
          :value="item.attributes.description"
          max-rows="6"
          no-resize
        ></b-form-textarea>
        <pre @click="edit" v-if="!editing">{{item.attributes.description}}</pre>
      </div>
    </template>
    <template v-else-if="$root.isOwner">
      <p id="add-description" @click="edit">
        Add description
        <i class="fas fa-pencil-alt"></i>
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: function(){
    return {
      editing: false
    }
  },
  computed: {
    ...mapState(['item']),
    renderDescription: function(){
      if(this.$root.isOwner) return true
      if(!this.item.attributes.description) return false

      return true;
    },
  },
  methods: {
    update: function(){
      const vm = this;
      let description = this.$refs.description.$refs.input.value.trim();
      if(description.length == 0){ description = null; }

      if(description != this.item.attributes.description){
        vm.$store.dispatch('updateItem', { itemId: this.item.id, body: { description }})
        .then(() => {
          vm.$root.toastSuccess('Description updated');
          vm.editing = false;
        })
        .catch(() => vm.$root.toastError('Could not update description, please try again.'));
      } else {
        vm.editing = false;
      }
    },
    edit: function(){
      const vm = this;
      if(!vm.$root.isOwner) { return; }

      vm.editing = true;
      vm.$nextTick(function(){
        vm.$refs.description.focus();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/packs/application.scss';

  #add-description {
    margin: 0;
    text-align: center;
    cursor: pointer;
    color: $dark-gray;

    &:hover {
      color: $viewer-blue;
    }
  }

  h5{
    font-size: 1rem;
    color: $dark-gray;
    font-weight: bold;
  }

  textarea {
    border: 0;
    outline: 0;
    width: 100%;
    background: transparent;

    &:focus {
      padding: 0;
      box-shadow: none;
      background: transparent;
    }
  }

  textarea, pre {
    margin: 0;
    font-family: SFpro;
    font-size: 1rem;
  }

  pre {
    max-width: 90%;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

</style>
